// Color system utilities - Professional minimal palette

export const ageGroupColors = {
  'Littles': '#FEF3C7', // Soft yellow
  'Kids': '#FDBA74', // Rich orange - deeper and more vibrant
  'Teens': '#D1FAE5', // Fresh mint
  'Young Adults': '#DBEAFE', // Sky blue
  'Adults': '#FCA5A5', // Rich red - deeper and more vibrant
};

export const specialClassColors = {
  'Gidha': '#F8B4D9', // Pink - slightly darker, premium tone
  'Dhol': '#4B5563', // Bold grey - dark, clean, modern
  'Bollywood': '#F59E0B', // Gold - slightly darker, elegant
  'Competition': '#8B5CF6', // Vibrant purple - strong, bold, stands out
  'Choreo': '#E0E7FF', // Soft indigo - subtle, muted, professional
  'Other': '#E5E7EB', // Light grey - neutral, subtle, minimal
};

export const rumaalRankColors = {
  'White': '#FFFFFF',
  'Yellow': '#FCD34D',
  'Green': '#10B981',
  'Blue': '#3B82F6',
  'Red': '#EF4444',
  'Black': '#1F2937',
};

export const getClassBackgroundColor = (classType, ageGroup) => {
  if (['Gidha', 'Dhol', 'Bollywood', 'Competition', 'Choreo', 'Other'].includes(classType)) {
    return specialClassColors[classType];
  }
  return ageGroupColors[ageGroup] || '#F3F4F6';
};

export const getClassBorderColor = (classType, ageGroup) => {
  if (['Gidha', 'Dhol', 'Bollywood', 'Competition', 'Choreo', 'Other'].includes(classType)) {
    return ageGroupColors[ageGroup] || '#000000';
  }
  return 'transparent';
};

export const getRumaalColor = (rank) => {
  return rumaalRankColors[rank] || '#9CA3AF';
};

// Student status colors - soft pastel tones
export const studentStatusColors = {
  'Active': '#BFDBFE', // Pastel blue
  'Paused': '#FECACA', // Pastel red
  'Trial': '#E5E7EB', // Pastel grey
  'Cash': '#BBF7D0', // Pastel green
};

export const getStudentStatusColor = (status) => {
  return studentStatusColors[status] || '#E5E7EB'; // Default to pastel grey
};

// Determine if text should be light or dark based on background color
export const getTextColorForBackground = (backgroundColor) => {
  // Convert hex to RGB
  const hex = backgroundColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  
  // Calculate relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  
  // Return light text for dark backgrounds, dark text for light backgrounds
  return luminance < 0.5 ? 'light' : 'dark';
};

